import { AuthForm } from './AuthForm'

/** `/register`. Public-only: a signed-in user is sent on. SUAP-0202. */
export function Register() {
  return <AuthForm mode="register" />
}
